import { render, staticRenderFns } from "./assayAddress.vue?vue&type=template&id=b4cb60c6&scoped=true"
import script from "./assayAddress.vue?vue&type=script&lang=js"
export * from "./assayAddress.vue?vue&type=script&lang=js"
import style0 from "./assayAddress.vue?vue&type=style&index=0&id=b4cb60c6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4cb60c6",
  null
  
)

export default component.exports